// src/components/auth/PolicyCheckbox.tsx
import React from "react";

export default function PolicyCheckbox(props: {
  checked: boolean;
  onChange: (v: boolean) => void;
  translate: (k: string) => string;
  disabled?: boolean;
}) {
  const { checked, onChange, translate, disabled = false } = props;

  return (
    <div className="col-lg-12 mb-2">
      <div
        className="form-check d-flex align-items-start"
        style={{
          background: "#f9fafb",
          border: "1px solid #e5e7eb",
          borderRadius: "6px",
          padding: "10px 12px 10px 38px",
        }}
      >
        <input
          className="form-check-input"
          id="register-privacy-policy"
          type="checkbox"
          checked={checked}
          disabled={disabled}
          style={{ width: "18px", height: "18px", marginTop: "2px" }}
          onChange={(e) => onChange(e.target.checked)}
        />

        <label
          className="form-check-label"
          htmlFor="register-privacy-policy"
          style={{ lineHeight: 1.4, color: "#374151" }}
        >
          {translate("I agree to")}{" "}
          <a href="https://aida-dz.xyz" target="_blank" rel="noreferrer">
            {translate("privacy policy & terms")}
          </a>
        </label>
      </div>
    </div>
  );
}
